import React, { useState } from "react";
import "../../../assets/styles/patients.scss";
import UsersImg from '../../../assets/images/users.svg';
import User2Img from '../../../assets/images/user-2.svg';
import User3Img from '../../../assets/images/user-3.svg';
import User4Img from '../../../assets/images/user-4.svg';
import DateSelect from "../../common/dateSelect.js";
import { commonPostApi } from "../../../utils/apiService";
import { API_ENDPOINTS } from "../../../utils/apiEndpoints";

const PatientDashboard = () => {
  const [dashboard, setDashboard] = useState([]);
  const [show, setShow] = useState(false);
  const [selectOption, setSelectOption] = useState(1);

  const fetchPatientDashboardData = async (startDate, endDate) => {
    await commonPostApi(API_ENDPOINTS.PATIENT_DASHBOARD, {
      startDate: startDate,
      endDate: endDate,
    })
      .then((response) => {
        setDashboard(response?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const dashoardDetails = (counts) => {
    const patient = dashboard?.find((item) => item?.status === counts);
    return patient?.count || 0;
  };

  return (
    <div className=" mt-4 mb-4 ">
      <DateSelect
        show={show}
        setShow={setShow}
        onDateRangeChange={fetchPatientDashboardData}
        selectOption={selectOption}
        setSelectOption={setSelectOption}
      />
      <div className="Patients__card-container">
        <ul className="Patients__card-holder">
          <li>
            <div className="card-left-sec">
              <p className="card-title">Visits</p>
              <p className="card-info">
                <span className="total-count">
                  {dashoardDetails("visits")}
                </span>
              </p>
            </div>
            <div className="card-right-sec">
              <span className="card-icon bg-one">
                <img src={UsersImg} alt="" />
              </span>
            </div>
          </li>

          <li>
            <div className="card-left-sec">
              <p className="card-title">Scheduled Surgeries</p>
              <p className="card-info">
                <span className="total-count">
                  {dashoardDetails("scheduled")}
                </span>
              </p>
            </div>
            <div className="card-right-sec">
              <span className="card-icon bg-two">
                <img src={User2Img} alt="" />
              </span>
            </div>
          </li>
          <li>
            <div className="card-left-sec">
              <p className="card-title">Arrived Patients</p>
              <p className="card-info">
                <span className="total-count">
                  {dashoardDetails("arrived")}
                </span>
              </p>
            </div>
            <div className="card-right-sec">
              <span className="card-icon bg-three">
                <img src={User3Img} alt="" />
              </span>
            </div>
          </li>
          <li>
            <div className="card-left-sec">
              <p className="card-title">Missed Surgeries</p>
              <p className="card-info">
                <span className="total-count">
                  {dashoardDetails("missed")}
                </span>
              </p>
            </div>
            <div className="card-right-sec">
              <span className="card-icon bg-four">
                <img src={User4Img} alt="" />
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PatientDashboard;

